export function formatClientGroupName(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) {
    return trimmed;
  }

  const groupMatch = trimmed.match(/^(.+?)(\s+)(group)$/i);

  if (!groupMatch) {
    return trimmed.toUpperCase();
  }

  const [, prefix, space, groupWord] = groupMatch;
  const normalizedGroupWord = groupWord === groupWord.toUpperCase() ? groupWord : "Group";

  return `${prefix.toUpperCase()}${space}${normalizedGroupWord}`;
}
